<template>
  <section>
    <b-card class="report-table">
      <div class="title">
        <p>{{ title }}</p>
      </div>
      <div class="mb-2">
        <b-row>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-start"
          >
            <b-button size="sm" variant="outline-primary" @click="goBackReport">
              回上頁
            </b-button>
            <div class="d-flex align-items-center" v-if="topExcel">
              <b-button
                @click="exportToExcel"
                class="ml-1"
                size="sm"
                variant="outline-primary"
              >
                Excel
              </b-button>
              <span style="color: red" v-show="showExportTextVal">
                (Excel 數據加載中...)
              </span>
            </div>
          </b-col>
          <!-- dayboxoffice 的日期/筛选与 Search 都在下方专属区块内，这里不再重复渲染 -->
          <b-col
            class="d-flex align-items-center justify-content-start mt-1"
            v-if="type !== 'toprank' && type !== 'dayboxoffice'"
          >
            <b-form-select
              v-if="showHKSelect"
              class="mr-1"
              style="width: 20%"
              @change="handleOptionChange"
              v-model="selectValueHighestOption"
              :options="selectHighestOptions"
            ></b-form-select>
            <b-form-input
              style="width: 20%"
              class="mr-1"
              :placeholder="placeholderVal"
              v-if="showSearchInput"
              v-model="searchInput"
              @input="searchChange"
            ></b-form-input>
            <datePickerCom
              v-if="type === 'highestsingleday'"
              :pickTimeVal.sync="from"
              :inputWidth="'200px'"
              class="mr-1"
              @getRecords="handleDateChange"
            />
            <datePickerCom
              v-if="type === 'highestsingleday'"
              :pickTimeVal.sync="to"
              :inputWidth="'200px'"
              class="mr-1"
              @getRecords="handleDateChange"
            />
            <b-button
              variant="primary"
              @click="search()"
            >
              Search
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-1" v-if="excel">
          <div class="d-flex align-items-center">
            <b-button
              @click="exportToExcel"
              class="ml-1"
              size="sm"
              variant="outline-primary"
            >
              Excel
            </b-button>
            <span style="color: red" v-show="showExportTextVal">
              (Excel 數據加載中...)
            </span>
          </div>
        </b-row>
        <b-row v-if="type === 'toprank'">
          <b-col>
            <div class="d-flex align-items-center">
              <p class="sub-title mr-2 filter-text my-0">
                已選擇的日子:
                {{ $moment(from).format() }} 至
                {{ $moment(to).format() }}
                <span v-if="selectedCriteriaShow" class="filter-separator">/</span>
                <span class="filter-criteria">{{ selectedCriteriaShow }}</span>
                <span v-if="selectedCriteriaShow" class="filter-separator">/</span>
                <span class="filter-run-type">{{ selectedRunTypeShow }}</span>
                <span class="filter-genre">{{ selectedGenreShow }}</span>
                <span class="filter-level">{{ selectedLevelShow }}</span>
                <span class="filter-version">{{ selectedVersionShow }}</span>
                <span class="filter-origin">{{ selectedOriginShow }}</span>
                <span class="filter-holiday">{{ selectedHolidayShow }}</span>
                <span class="filter-month">{{ selectedMonthShow }}</span>
                <span class="filter-weekday">{{ selectedWeekdayShow }}</span>
                <span class="filter-public-holiday">{{
                  selectedPublicHolidayShow
                }}</span>
                <span class="filter-weekday-holiday-logic">{{
                  selectedWeekdayHolidayLogicShow
                }}</span>
                <span class="filter-theatre-day">{{
                  selectedTheatreDaysShow
                }}</span>
              </p>
              <b-button variant="primary" @click="search()"> Search </b-button>
              <b-button
                variant="outline-primary"
                class="nowrap"
                style="white-space: nowrap; margin-left: 20px"
                v-b-toggle.collapse-1
              >
                選擇更多選項
              </b-button>
            </div>
            <div>
              <b-collapse id="collapse-1" class="mt-2">
                <div class="sub-title mb-1">選擇更多選項</div>
                <b-card class="border mb-0">
                  <p class="sub-title mt-0">選擇時間</p>
                  <div class="d-flex mt-2">
                    <datePickerCom
                      :pickTimeVal.sync="from"
                      :inputWidth="'200px'"
                      class="mr-1"
                      @getRecords="handleDateChange"
                    />
                    <datePickerCom
                      :pickTimeVal.sync="to"
                      :inputWidth="'200px'"
                      class="mr-1"
                      @getRecords="handleDateChange"
                    />
                  </div>
                  <p class="sub-title">選擇搜尋條件</p>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="selectedCriteria"
                      :options="optionsCriteria"
                      class="demo-inline-spacing"
                      @change="handleCriteriaChange"
                    />
                  </b-form-group>
                  <p class="sub-title">輪次口徑（首映 / 重映）</p>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="selectedRunType"
                      :options="runTypeOptions"
                      class="demo-inline-spacing"
                      @change="handleRunTypeChange"
                    />
                    <small class="text-muted d-block">
                      首映＝只取該片首輪（輪次 1.0）的場次，與舊版一致；重映＝其餘輪次；全部＝兩者都要。選「重映／全部」時同一部片的不同輪次會各自成一行，清單的電影名稱會標示輪次。
                    </small>
                  </b-form-group>
                  <p class="sub-title">選擇周天 (可多項選擇，[累積/首日/首週]為該周天開畫或[單日最高]為該周天)</p>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="selectedWeekday"
                      :options="optionsWeekday"
                      class="demo-inline-spacing"
                      @change="handleWeekdayChange"
                    />
                  </b-form-group>
                  <p class="sub-title">公眾假期（香港）</p>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="selectedPublicHoliday"
                      :options="publicHolidayOptions"
                      :disabled="!publicHolidaySupported"
                      class="demo-inline-spacing"
                      @change="handlePublicHolidayChange"
                    />
                    <small class="text-muted d-block">
                      僅「累積／首日／首週／最高單日」相關的搜尋條件支援此篩選；累積／首日／首週按開畫日篩（與「特殊節日」不同，此處指全部香港公眾假期）。
                    </small>
                    <small
                      v-if="!publicHolidaySupported"
                      class="text-danger d-block"
                    >
                      目前搜尋條件「{{ selectedCriteriaShow }}」不支援公眾假期篩選。
                    </small>
                  </b-form-group>
                  <p class="sub-title">周天與公眾假期的組合邏輯</p>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="selectedWeekdayHolidayLogic"
                      :options="weekdayHolidayLogicOptions"
                      :disabled="
                        selectedWeekday.length === 0 || !selectedPublicHoliday
                      "
                      class="demo-inline-spacing"
                      @change="handleWeekdayHolidayLogicChange"
                    />
                    <small class="text-muted d-block">
                      需同時設定「周天」與「公眾假期」才生效；不設定時為 AND。
                    </small>
                    <small
                      v-if="
                        isHolidaySundayEmpty(
                          selectedWeekday,
                          selectedWeekdayHolidayLogic,
                          selectedPublicHoliday
                        )
                      "
                      class="text-danger d-block"
                    >
                      香港公眾假期不含週日，「星期日 + 只限公眾假期 + AND」會是空結果；如需「假日＋週末」請改選 OR。
                    </small>
                  </b-form-group>
                  <p class="sub-title">戲院日（可多項選擇）</p>
                  <b-form-group>
                    <el-select
                      v-model="selectedTheatreDays"
                      multiple
                      filterable
                      placeholder="請選擇戲院日"
                      style="width: 100%; max-width: 600px"
                      @change="handleTheatreDayChange"
                    >
                      <el-option
                        v-for="item in optionsTheatreDays"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      />
                    </el-select>
                    <small v-if="!theatreDaySupported" class="text-danger d-block">
                      目前搜尋條件「{{ selectedCriteriaShow }}」不支援戲院日篩選。
                    </small>
                    <small v-else class="text-muted d-block">
                      只保留日期命中所選戲院日的影片（累積／首日／首週按開畫日、最高單日按上榜日）。
                    </small>
                  </b-form-group>
                  <p class="sub-title">選擇上映月份 (可多項選擇)</p>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="selectedMonth"
                      :options="optionsMonth"
                      class="demo-inline-spacing"
                      @change="handleMonthChange"
                    />
                  </b-form-group>
                  <p class="sub-title">選擇特殊節日上映影片</p>
                  <b-form-checkbox
                      v-model="enableHoliday"
                      class="my-2"
                      @change="handleEnableHolidayChange"
                  >
                    啟用特殊節日篩選
                  </b-form-checkbox>
                  <div v-if="enableHoliday" class="mt-2">
                    <div v-for="(holidayGroup, index) in holidayGroups" :key="index" class="d-flex align-items-center mb-2 holiday-group-item">
                      <span class="mr-2 font-weight-bold">{{ index + 1 }}.</span>
                      <b-form-group label="選擇節日：" label-cols="auto" class="mb-0 mr-3">
                        <el-select
                            v-model="holidayGroup.selectedHoliday"
                            placeholder="請選擇節日"
                            style="width: 300px"
                            filterable
                            @change="(val) => handleHolidayChange(val, index)"
                        >
                          <el-option
                              v-for="holiday in allHolidayList"
                              :key="holiday.code"
                              :label="holiday.name"
                              :value="holiday.code"
                          />
                        </el-select>
                      </b-form-group>
                      <b-button
                          v-if="holidayGroups.length > 1"
                          size="sm"
                          variant="outline-danger"
                          @click="removeHolidayGroup(index)"
                          class="ml-2"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </div>
                    <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="addHolidayGroup"
                        class="mt-2"
                    >
                      <feather-icon icon="PlusIcon" /> 新增節日組合
                    </b-button>
                  </div>
                  <p class="sub-title">按片種排序 (可多項選擇)</p>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="selectedGenre"
                      :options="optionsGenre"
                      class="demo-inline-spacing"
                      @change="handleGenreChange"
                    />
                  </b-form-group>
                  <p class="sub-title">按級別排序 (可多項選擇）</p>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="selectedLevel"
                      :options="optionsLevel"
                      class="demo-inline-spacing"
                      @change="handleLevelChange"
                    />
                  </b-form-group>
                  <p class="sub-title">按版本排序 (可多項選擇）</p>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="selectedVersion"
                      :options="optionsVersion"
                      class="demo-inline-spacing"
                      @change="handleVersionChange"
                    />
                  </b-form-group>
                  <p class="sub-title">按產地排序 (可多項選擇）</p>
                  <b-form-input v-model="searchCountry" placeholder="搜尋產地" class="mt-1 search-country"></b-form-input>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="selectedOrigin"
                      :options="countryOptions"
                      class="demo-inline-spacing"
                      @change="handleOriginChange"
                    />
                  </b-form-group>
                </b-card>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
        <!-- 22.6.2 最高票房日期（最好生意）：日期区间 + 日期属性（周天/月份/節日）筛选 -->
        <b-row v-if="type === 'dayboxoffice'">
          <b-col>
            <div class="d-flex align-items-center">
              <p class="sub-title mr-2 filter-text my-0">
                已選擇的日子:
                {{ $moment(from).format() }} 至
                {{ $moment(to).format() }}
                <span class="filter-separator">/</span>
                <span class="filter-month">{{ selectedMonthShowPayload }}</span>
                <span class="filter-weekday">{{ selectedWeekdayShowPayload }}</span>
                <span class="filter-holiday">{{ selectedHolidayShowPayload }}</span>
                <span class="filter-public-holiday">{{
                  selectedPublicHolidayShowPayload
                }}</span>
                <span class="filter-weekday-holiday-logic">{{
                  selectedWeekdayHolidayLogicShowPayload
                }}</span>
                <span class="filter-theatre-day">{{
                  selectedTheatreDaysShowPayload
                }}</span>
              </p>
              <b-button variant="primary" @click="search()"> Search </b-button>
              <b-button
                variant="outline-primary"
                class="nowrap"
                style="white-space: nowrap; margin-left: 20px"
                v-b-toggle.collapse-day-box-office
              >
                選擇更多選項
              </b-button>
            </div>
            <div>
              <b-collapse id="collapse-day-box-office" class="mt-2">
                <div class="sub-title mb-1">選擇更多選項</div>
                <b-card class="border mb-0">
                  <p class="sub-title mt-0">選擇時間</p>
                  <div class="d-flex mt-2">
                    <datePickerCom
                      :pickTimeVal.sync="from"
                      :inputWidth="'200px'"
                      class="mr-1"
                      @getRecords="handleDateChange"
                    />
                    <datePickerCom
                      :pickTimeVal.sync="to"
                      :inputWidth="'200px'"
                      class="mr-1"
                      @getRecords="handleDateChange"
                    />
                  </div>
                  <p class="sub-title">選擇周天（該日期為，可多項選擇）</p>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="payloadWeekday"
                      :options="payloadWeekdayOptions"
                      class="demo-inline-spacing"
                      @change="handlePayloadWeekdayChange"
                    />
                  </b-form-group>
                  <p class="sub-title">選擇月份（該日期所屬月份，可多項選擇）</p>
                  <b-form-group>
                    <b-form-checkbox-group
                      v-model="payloadMonth"
                      :options="optionsMonth"
                      class="demo-inline-spacing"
                      @change="handlePayloadMonthChange"
                    />
                  </b-form-group>
                  <p class="sub-title">
                    選擇公眾假期（該日期是否為香港公眾假期）
                  </p>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="payloadPublicHoliday"
                      :options="publicHolidayOptions"
                      class="demo-inline-spacing"
                      @change="handlePayloadPublicHolidayChange"
                    />
                    <small class="text-muted d-block">
                      與下方「特殊節日」不同，此處指全部香港公眾假期。
                    </small>
                  </b-form-group>
                  <p class="sub-title">周天與公眾假期的組合邏輯</p>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="payloadWeekdayHolidayLogic"
                      :options="weekdayHolidayLogicOptions"
                      :disabled="
                        payloadWeekday.length === 0 || !payloadPublicHoliday
                      "
                      class="demo-inline-spacing"
                      @change="handlePayloadWeekdayHolidayLogicChange"
                    />
                    <small class="text-muted d-block">
                      需同時設定「周天」與「公眾假期」才生效；不設定時為 AND。
                    </small>
                    <small
                      v-if="
                        isHolidaySundayEmpty(
                          payloadWeekday,
                          payloadWeekdayHolidayLogic,
                          payloadPublicHoliday
                        )
                      "
                      class="text-danger d-block"
                    >
                      香港公眾假期不含週日，「星期日 + 只限公眾假期 + AND」會是空結果；如需「假日＋週末」請改選 OR。
                    </small>
                  </b-form-group>
                  <p class="sub-title">戲院日（該日期為所選戲院日，可多項選擇）</p>
                  <b-form-group>
                    <el-select
                      v-model="payloadTheatreDays"
                      multiple
                      filterable
                      placeholder="請選擇戲院日"
                      style="width: 100%; max-width: 600px"
                      @change="handlePayloadTheatreDayChange"
                    >
                      <el-option
                        v-for="item in optionsTheatreDays"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      />
                    </el-select>
                    <small class="text-muted d-block">
                      只保留日期命中所選戲院日的資料（與其他條件取交集）。
                    </small>
                  </b-form-group>
                  <p class="sub-title">選擇特殊節日（該日期為節日）</p>
                  <b-form-checkbox
                    v-model="payloadEnableHoliday"
                    class="my-2"
                    @change="handlePayloadEnableHolidayChange"
                  >
                    啟用特殊節日篩選
                  </b-form-checkbox>
                  <div v-if="payloadEnableHoliday" class="mt-2">
                    <div
                      v-for="(holidayGroup, index) in payloadHolidayGroups"
                      :key="index"
                      class="d-flex align-items-center mb-2 holiday-group-item"
                    >
                      <span class="mr-2 font-weight-bold">{{ index + 1 }}.</span>
                      <b-form-group
                        label="選擇節日："
                        label-cols="auto"
                        class="mb-0 mr-3"
                      >
                        <el-select
                          v-model="holidayGroup.selectedHoliday"
                          placeholder="請選擇節日"
                          style="width: 300px"
                          filterable
                          @change="
                            (val) => handlePayloadHolidayChange(val, index)
                          "
                        >
                          <el-option
                            v-for="holiday in allHolidayList"
                            :key="holiday.code"
                            :label="holiday.name"
                            :value="holiday.code"
                          />
                        </el-select>
                      </b-form-group>
                      <b-button
                        v-if="payloadHolidayGroups.length > 1"
                        size="sm"
                        variant="outline-danger"
                        @click="removePayloadHolidayGroup(index)"
                        class="ml-2"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </div>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      @click="addPayloadHolidayGroup"
                      class="mt-2"
                    >
                      <feather-icon icon="PlusIcon" /> 新增節日
                    </b-button>
                  </div>
                </b-card>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="type === 'highestsingleday'">
          <b-col>
            <div class="d-flex">
              <p class="sub-title" style="width: 50%">
                <span
                  >已選擇的日子:{{ $moment(from).format() }} /
                  {{ $moment(to).format() }}</span
                >
                <span class="black-text ml-2">首 100 位（只有輪次 1）</span>
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mb-2 d-flex align-items-center" v-if="showTitleText">
        <span class="mr-1" style="color: #0e72bc"
          >{{ titleVal.year }}年有{{ titleVal.num_film }}部影片,票房總計為{{
            titleVal.bo_total
          }}</span
        >
        <b-button size="sm" variant="outline-primary" @click="exportToExcel"
          >Detail</b-button
        >
        <span style="color: red" v-show="showExportText">
          (Excel數據加載中...)
        </span>
      </div>
      <div class="mb-2 d-flex align-items-center" v-if="type === 'version'">
        <span class="mr-1" style="color: #0e72bc"
          >{{ year }}年年度首輪，日期截至{{ cutDate }}</span
        >
      </div>
      <div>
        <b-table
          bordered
          hover
          responsive
          :fields="
            $store.state.highlightCol.firTable
              ? $store.state.newTableFields
              : fields
          "
          @head-clicked="handleHeadClicked"
          :items="items"
          :per-page="clientPagination ? perPage : null"
          :current-page="clientPagination ? currentPageVal : null"
          :no-local-sorting="type === 'toprank'"
          :sort-by="tableSortBy"
          :sort-desc="tableSortDesc"
          @sort-changed="handleSortChanged"
          :sticky-header="stickyHeader ? stickyHeaderHeight : false"
          :thead-class="stickyHeader ? 'sticky-thead' : ''"
          :table-class="stickyHeader ? 'sticky-table' : ''"
        >
          <template #head()="row">
            <div
              class="text-nowrap"
              :style="`background:${highlightTopLabel(
                row.field.key
              )};min-width:50px`"
            >
              {{ row.label }}
            </div>
          </template>
          <template #cell(name)="row">
            <div style="width: 100px">{{ row.item.name }}</div>
          </template>
          <template #cell(date_on)="row">
            <div class="text-nowrap" :class="{ 'text-red': row.item.is_pre_show}">
              {{ isValidDate(row.value) }}{{ showRelease(row.item) }}
            </div>
          </template>
          <template #cell(single_day_highest_date)="row">
            <div class="text-nowrap">
              {{ displayDate(row.item.single_day_highest_date) }}
            </div>
          </template>
          <template #cell(date_release)="row">
            <div class="text-nowrap">
              {{ displayDate(row.item.date_release) }}{{ showRelease(row.item) }}
            </div>
          </template>
          <template #cell(date)="row">
            <div class="text-nowrap">
              {{ formatDateDMY(row.item.date) }}
            </div>
          </template>
          <template #cell(date_off)="row">
            <div class="text-nowrap">
              {{ displayDateOff(row.item) }}
            </div>
          </template>
          <template #cell(accum_bo)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.accum_bo).toLocaleString() }}
            </div>
          </template>
          <template #cell(box_office)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.box_office).toLocaleString() }}
            </div>
          </template>
          <!-- highestSingelDay -->
          <template #cell(visit_cummulative)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.visit_cummulative).toLocaleString() }}
            </div>
          </template>
          <template #cell(bo_cummulative)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.bo_cummulative).toLocaleString() }}
            </div>
          </template>
          <template #cell(highest_number_visitors)="row">
            <div class="text-nowrap">
              {{
                parseFloat(row.item.highest_number_visitors).toLocaleString()
              }}
            </div>
          </template>
          <template #cell(single_day_highest)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.single_day_highest).toLocaleString() }}
            </div>
          </template>
          <template #cell(max_number_session_in_day)="row">
            <div class="text-nowrap">
              {{
                parseFloat(row.item.max_number_session_in_day).toLocaleString()
              }}
            </div>
          </template>
          <template #cell(max_number_screens_in_day)="row">
            <div class="text-nowrap">
              {{
                parseFloat(row.item.max_number_screens_in_day).toLocaleString()
              }}
            </div>
          </template>
          <!-- top ranking -->
          <!-- 後端 2026-09 起把 highest_date_on_* 一律回字串（無資料為 "0"），
               所以不能用 === 0 判空（永遠為 false，會把「無優先場」顯示成 0）。
               改用 Number() 後判真假：0 / NaN / null 一律顯示 "-"。 -->
          <template #cell(highest_date_on_ad)="row">
            <div class="text-nowrap">
              {{
                Number(row.item.highest_date_on_ad)
                  ? parseFloat(row.item.highest_date_on_ad).toLocaleString()
                  : "-"
              }}
            </div>
          </template>
          <template #cell(highest_date_on_bo)="row">
            <div class="text-nowrap">
              {{
                Number(row.item.highest_date_on_bo)
                  ? parseFloat(row.item.highest_date_on_bo).toLocaleString()
                  : "-"
              }}
            </div>
          </template>
          <template #cell(visit_cummulative)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.visit_cummulative).toLocaleString() }}
            </div>
          </template>
          <template #cell(single_day_highest_visitors)="row">
            <div class="text-nowrap">
              {{
                parseFloat(
                  row.item.single_day_highest_visitors
                ).toLocaleString()
              }}
            </div>
          </template>
          <template #cell(first_week_visitors)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.first_week_visitors).toLocaleString() }}
            </div>
          </template>
          <template #cell(bo_first)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.bo_first).toLocaleString() }}
            </div>
          </template>
          <template #cell(visitors)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.visitors).toLocaleString() }}
            </div>
          </template>
          <template #cell(first_day_bo)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.first_day_bo).toLocaleString() }}
            </div>
          </template>
          <!-- 22.6.2 day box office -->
          <template #cell(num_show)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.num_show).toLocaleString() }}
            </div>
          </template>
          <template #cell(num_film)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.num_film).toLocaleString() }}
            </div>
          </template>
          <template #cell(bo)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.bo).toLocaleString() }}
            </div>
          </template>
          <template #cell(ad)="row">
            <div class="text-nowrap">
              {{ parseFloat(row.item.ad).toLocaleString() }}
            </div>
          </template>
        </b-table>
        <div
          v-if="clientPagination && items.length > perPage"
          class="mt-2 d-flex justify-content-end"
        >
          <b-pagination
            v-model="currentPageVal"
            :total-rows="items.length"
            :per-page="perPage"
          />
        </div>
        <!-- 22.5：服務端分頁，總頁數 = ceil(total / per_page) -->
        <div
          v-if="serverPagination && pageTotal > rows"
          class="mt-2 d-flex justify-content-end"
        >
          <b-pagination
            :value="currentPage"
            :total-rows="pageTotal"
            :per-page="rows"
            @change="handleServerPageChange"
          />
        </div>
      </div>
      <p v-if="type === 'highestsingleday'">紅色highlight代表合拍電影</p>
      <p v-if="path === 'report-year-version'">紅色highlight代表有優先場</p>
    </b-card>
  </section>
</template>
<script>
import { BCollapse, VBToggle } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import datePickerCom from '@/views/components/datePicker.vue'
import { getCalendarByYear } from '@/api/calendar'
import { getManageProperties } from '@/api/properties'
export default {
  name: 'TableDataListing',
  components: {
    BCollapse,
    datePickerCom
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  props: {
    year: {
      type: String,
      default: ''
    },
    cutDate: {
      type: String,
      default: ''
    },
    topExcel: {
      type: Boolean,
      default: false
    },
    showExportText: {
      type: Boolean,
      default: false
    },
    showTitleText: { type: Boolean, default: false },
    titleVal: { type: Object },
    placeholderVal: { type: String, default: '' },
    showSearchInput: {
      type: Boolean,
      default: false
    },
    showHKSelect: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    fields: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    optionsCriteria: {
      type: Array,
      default: () => []
    },
    optionsGenre: {
      type: Array,
      default: () => []
    },
    optionsLevel: {
      type: Array,
      default: () => []
    },
    optionsVersion: {
      type: Array,
      default: () => []
    },
    optionsOrigin: {
      type: Array,
      default: () => []
    },
    optionsWeekday: {
      type: Array,
      default: () => []
    },
    pageTotal: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    rows: {
      type: Number,
      required: true
    },
    clientPagination: {
      type: Boolean,
      default: false
    },
    // 22.5：分頁交由服務端（page / per_page + total），前端只發 pageChange
    serverPagination: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 50
    },
    stickyHeader: {
      type: Boolean,
      default: false
    },
    stickyHeaderHeight: {
      type: String,
      default: 'calc(100vh - 260px)'
    },
    path: {
      type: String,
      default: ''
    },
    excel: {
      type: Boolean,
      default: false
    },
    returnData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      searchInput: '',
      filter: null,
      filterOn: [],
      currentPageVal: 1,
      // 22.5：服務端排序；orderBy = order_by、sortFieldKey 只用於表頭箭頭
      orderBy: 'total_bo',
      sortDesc: true,
      sortFieldKey: 'bo_cummulative',
      // 表頭排序請求回來後要標藍的欄位（非表頭排序請求會清空 → 還原藍底）
      sortHighlightKey: '',
      selectValue: window.sessionStorage.getItem('area') || '',
      selectValueHighestOption: '',
      selectHighestOptions: [
        { value: '', text: '全部地區' },
        { value: 'Hong Kong', text: '香港' },
        { value: 'non Hong Kong', text: '非香港' }
      ],
      searchQuery: {
        search: '',
        location: ''
      },
      from: '',
      to: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
      disabledDatesFrom: {
        to: '',
        from: null
      },
      disabledDatesTo: {
        to: ''
      },
      selectedCriteria: 'total_bo',
      selectedCriteriaShow: '累積票房',
      // 22.5：輪次口徑 run_type —— '' = 首映（不傳參數，與改動前一致）/ re / all
      selectedRunType: '',
      selectedRunTypeShow: '',
      selectedGenreShow: '',
      selectedLevelShow: '',
      selectedVersionShow: '',
      selectedOriginShow: '',
      selectedMonth: [],
      selectedMonthShow: '',
      selectedWeekday: [],
      selectedWeekdayShow: '',
      selectedGenre: [],
      selectedLevel: [],
      selectedVersion: [],
      selectedOrigin: [],
      searchCountry: '',
      enableHoliday: false,
      holidayGroups: [],
      selectedHolidayShow: '',
      allHolidayList: [],
      // 22.6.2 最高票房日期（最好生意）：独立 state，避免与 top-ranking 的 query string 逻辑互相影响
      payloadWeekday: [],
      payloadMonth: [],
      payloadEnableHoliday: false,
      payloadHolidayGroups: [],
      selectedWeekdayShowPayload: '',
      selectedMonthShowPayload: '',
      selectedHolidayShowPayload: '',
      // public_holiday 三態：'' 不篩選 / '1' 只限公眾假期 / '0' 排除公眾假期
      selectedPublicHoliday: '',
      selectedPublicHolidayShow: '',
      payloadPublicHoliday: '',
      selectedPublicHolidayShowPayload: '',
      // weekday_holiday_logic：'and'（預設）/ 'or'，只作用於 weekday 與 public_holiday 之間
      selectedWeekdayHolidayLogic: 'and',
      selectedWeekdayHolidayLogicShow: '',
      payloadWeekdayHolidayLogic: 'and',
      selectedWeekdayHolidayLogicShowPayload: '',
      // 戲院日（manage_properties type=theatre_day_list）：名稱存 name_en、值（日期 Y-m-d）存 name_zh_hk
      optionsTheatreDays: [],
      selectedTheatreDays: [],
      selectedTheatreDaysShow: '',
      payloadTheatreDays: [],
      selectedTheatreDaysShowPayload: '',
    }
  },
  computed: {
    // 22.5：排序在服務端，b-table 只負責表頭箭頭
    tableSortBy() {
      return this.type === 'toprank' ? this.sortFieldKey : null
    },
    tableSortDesc() {
      return this.type === 'toprank' ? this.sortDesc : null
    },
    currentTableFields() {
      return this.$store.state.highlightCol.firTable
        ? this.$store.state.newTableFields
        : this.fields
    },
    showExportTextVal: {
      get() {
        return this.showExportText
      },
      set(value) {
        return this.$emit('update:showExportText', value)
      }
    },
    showRelease() {
      return function (val) {
        if (
          val.date_on !== '0001-01-01' &&
          new Date(val.date_on) < new Date(val.date_release) &&
          this.type === 'highestsingleday'
        ) {
          return '(優先場)'
        }
      }
    },
    dataListStart() {
      if (this.rows === 5) {
        return (this.currentPage - 1) * 5 + 1
      } else {
        return (this.currentPage - 1) * 2 * (this.rows / 2) + 1
      }
    },
    dataListStop() {
      if (this.currentPage === Math.ceil(this.pageTotal / this.rows)) {
        return this.pageTotal
      } else {
        return this.rows * this.currentPage
      }
    },
    countryOptions() {
      if (this.optionsOrigin.length > 0 && this.searchCountry) {
        return this.optionsOrigin.filter(item => item.text.toLowerCase().includes(this.searchCountry))
      } else if (this.optionsOrigin.length === 0 && this.searchCountry) {
        return []
      }
      return this.optionsOrigin
    },
    optionsMonth() {
      return [
        { value: '1', text: '1月' },
        { value: '2', text: '2月' },
        { value: '3', text: '3月' },
        { value: '4', text: '4月' },
        { value: '5', text: '5月' },
        { value: '6', text: '6月' },
        { value: '7', text: '7月' },
        { value: '8', text: '8月' },
        { value: '9', text: '9月' },
        { value: '10', text: '10月' },
        { value: '11', text: '11月' },
        { value: '12', text: '12月' }
      ]
    },
    // 22.6.2：接口 weekday 为 ISO-8601（1=周一…7=周日），故不提供「無」選項
    payloadWeekdayOptions() {
      return [
        { value: '1', text: '星期一' },
        { value: '2', text: '星期二' },
        { value: '3', text: '星期三' },
        { value: '4', text: '星期四' },
        { value: '5', text: '星期五' },
        { value: '6', text: '星期六' },
        { value: '7', text: '星期日' }
      ]
    },
    // 輪次口徑（run_type）：'' = 首映（不傳參數）/ re = 重映 / all = 全部
    // 標量單選，不要寫成 run_type[]（後端會 422）
    runTypeOptions() {
      return [
        { value: '', text: '首映' },
        { value: 're', text: '重映' },
        { value: 'all', text: '全部' }
      ]
    },
    // public_holiday 三態選項（22.5 與 22.6.2 共用）
    publicHolidayOptions() {
      return [
        { value: '', text: '不篩選' },
        { value: '1', text: '只限公眾假期' },
        { value: '0', text: '排除公眾假期' }
      ]
    },
    // weekday 與 public_holiday 的組合邏輯（只認 and / or）
    weekdayHolidayLogicOptions() {
      return [
        { value: 'and', text: '同時符合（AND）' },
        { value: 'or', text: '任一符合（OR）' }
      ]
    },
    // 22.5 / 2026-09 修訂（GET /highest）的 public_holiday 只在這些 sort_type 上生效
    // （見 docs/frontend-highest-handover-2026-09.md 第 5.5 節「日期維度篩選的落點」）：
    // 累積 total_* 自 2026-09 修訂起與首日／首週同落點，改為按開畫日 films.date_release 篩；
    // 最高優先場 highest_date_on_* 仍不生效，故不列入
    publicHolidaySupported() {
      const supported = [
        'total_bo',
        'total_ad',
        'first_day_bo',
        'first_day_ad',
        'first_week_bo',
        'first_week_ad',
        'highest_day_bo',
        'highest_day_ad'
      ]
      return supported.indexOf(this.selectedCriteria) > -1
    },
    // 戲院日的生效範圍與 public_holiday / weekday 相同
    // （見 docs/frontend-highest-handover-2026-09.md 第 5.5 節：三者同構，落點由 sort_type 決定）
    theatreDaySupported() {
      return this.publicHolidaySupported
    }
  },
  watch: {
    items() {
      this.currentPageVal = 1
      if (this.type !== 'toprank') {
        return
      }
      // 表頭排序請求回來 → 標示該欄藍底；非表頭排序的請求回來 → 還原藍底
      if (this.sortHighlightKey) {
        this.applySortHighlight()
      } else {
        this.resetSortHighlight()
      }
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.searchQuery.location = this.selectValue
    // const oneMonthAgoDate = new Date();
    // oneMonthAgoDate.setMonth(oneMonthAgoDate.getMonth() - 1);
    this.from = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
    this.getAllHolidays()
    // 只有 22.5 / 22.6.2 需要「戲院日」篩選，其餘報表不用打這支 API
    if (this.type === 'toprank' || this.type === 'dayboxoffice') {
      this.getTheatreDayList()
    }
    // 22.6.2：把默认日期区间同步给父组件，父组件无需自己维护默认值
    this.emitFilterPayload()
  },
  methods: {
    // 22.5：點表頭後要等排序請求回來才標藍（順序：請求 → 變藍 → 非表頭排序請求 → 還原），
    // 其餘報表維持原本「點表頭即高亮」
    handleHeadClicked(key) {
      if (this.type === 'toprank') {
        return
      }
      this.commonHighLightCol(
        key,
        this.fields,
        this.$store.state.newTableFields,
        'firTable'
      )
    },
    // 排序請求回來：把這次排序的欄位標藍
    applySortHighlight() {
      this.commonHighLightCol(
        this.sortHighlightKey,
        this.fields,
        this.$store.state.newTableFields,
        'firTable'
      )
    },
    // 22.5：commonHighLightCol 會把 variant:'info' 寫進欄位物件，非表頭排序請求後還原成一般樣式
    resetSortHighlight() {
      this.fields.forEach((el) => {
        if (el.variant) {
          el.variant = ''
        }
      })
      if (this.$store.state.highlightCol.firTable) {
        this.$store.commit('updateStateData')
      }
    },
    // 表頭底色：目前排序／分類的欄位加黃底（原本寫成 computed 回傳 function，this 用法會被 eslint 判為非法）
    highlightTopLabel(val) {
      if (this.selectedGenre.length > 0 && val === 'film') {
        return '#dcd355'
      }
      if (this.selectedLevel.length > 0 && val === 'level') {
        return '#dcd355'
      }
      if (this.selectedOrigin.length > 0 && val === 'origin') {
        return '#dcd355'
      }
      let key = ''
      this.optionsCriteria.map((el) => {
        if (this.selectedCriteria === el.value) {
          key = el.key
        }
      })
      if (key === val) {
        return '#dcd355'
      }
      return ''
    },
    getAllHolidays() {
      // 获取当前年份，如果需要可以获取多年数据
      const currentYear = new Date().getFullYear()
      getCalendarByYear(currentYear).then((res) => {
        if (res.data && Array.isArray(res.data)) {
          this.allHolidayList = res.data
        } else {
          this.allHolidayList = []
        }
      }).catch((error) => {
        console.error('Failed to fetch holiday list:', error)
        this.allHolidayList = []
      })
    },
    // 戲院日清單：只保留未停用且日期格式正確（Y-m-d 真實日期）的項目，
    // 避免 day-box-office 的 POST 因個別非法值整批 422（見 docs/api-special-records-theatre-days.md；
    // highest 的戲院日口徑見 docs/frontend-highest-handover-2026-09.md 第 3.5 / 5.5 節）
    getTheatreDayList() {
      getManageProperties('theatre_day_list')
        .then((res) => {
          const list = Array.isArray(res.data) ? res.data : []
          this.optionsTheatreDays = list
            .filter((el) => {
              const isValid = this.$moment(
                el.name_zh_hk,
                'YYYY-MM-DD',
                true
              ).isValid()
              return el.status !== '1' && isValid
            })
            .map((el) => ({
              value: el.name_zh_hk,
              text: `${el.name_en}（${el.name_zh_hk}）`
            }))
        })
        .catch(() => {
        })
    },
    handleEnableHolidayChange(val) {
      if (val && this.holidayGroups.length === 0) {
        this.addHolidayGroup()
      } else if (!val) {
        this.holidayGroups = []
        this.selectedHolidayShow = ''
        this.$emit('handleHolidayChange', '')
      }
    },
    addHolidayGroup() {
      this.holidayGroups.push({
        selectedHoliday: '',
        holidayName: ''
      })
    },
    removeHolidayGroup(index) {
      this.holidayGroups.splice(index, 1)
      this.updateSelectedHolidayShow()
    },
    handleHolidayChange(val, index) {
      const group = this.holidayGroups[index]
      const holiday = this.allHolidayList.find(h => h.code === val)
      group.holidayName = holiday ? holiday.name : ''
      this.updateSelectedHolidayShow()
    },
    updateSelectedHolidayShow() {
      const selectedHolidays = this.holidayGroups
        .filter(group => group.selectedHoliday && group.holidayName)
        .map(group => group.holidayName)
      
      this.selectedHolidayShow = `${selectedHolidays.length > 0
        ? `${selectedHolidays.join(' + ')}`
        : ''  }/`
      
      // 收集所有选中的节日 code，用逗号分隔
      const specialDays = this.holidayGroups
        .filter(group => group.selectedHoliday)
        .map(group => group.selectedHoliday)
      
      // 如果有选中的节日，使用 special_days= 参数，多个节日 code 用逗号分隔
      const specialDayParamStr = specialDays.length > 0 
        ? `&special_days=${specialDays.join(',')}`
        : ''

      this.$emit('handleHolidayChange', specialDayParamStr)
    },
    exportToExcel() {
      this.$emit('exportToExcel')
    },
    searchChange(val) {
      this.$emit('searchChange', val)
    },
    handleSearchChange() {
      this.$emit('handleSearchChange', this.searchQuery.search)
    },
    handleLocationChange() {
      let areaFilter = ''
      if (this.searchQuery.location === '全部地區') {
        areaFilter = ''
      } else if (this.searchQuery.location === '香港') {
        areaFilter = 'Hong Kong'
      } else {
        areaFilter = 'non Hong Kong'
      }
      this.$emit('handleLocationChange', areaFilter)
    },
    handleOptionChange() {
      this.$emit('handleOptionChange', this.selectValueHighestOption)
    },
    handleHighestChange() {
      this.$emit('handleHighestChange', this.selectValueHighestOption)
    },
    handleDateChange() {
      this.$emit('handleDateChange', this.from, this.to)
      this.emitFilterPayload()
    },
    // 22.6 / 22.6.1 的日期欄固定 MM-DD-YYYY；其餘報表維持原本行為
    displayDate(value) {
      if (this.type === 'highestsingleday') {
        return this.formatDateDMY(value)
      }
      return this.isValidDate(value)
    },
    displayDateOff(item) {
      return this.displayDate(
        this.dateOffFormat(item.date_off, item.date_release)
      )
    },
    // 22.5：sort_type（榜單類型，決定名單／total）與 order_by（表頭排序，只決定行序）
    // 是兩個正交參數，一律由服務端處理，此處只組 query string 片段
    sortParam() {
      const orderBy = this.orderBy ? `&order_by=${this.orderBy}` : ''
      return `&sort_type=${this.selectedCriteria}${orderBy}&sort_dir=${
        this.sortDesc ? 'desc' : 'asc'
      }`
    },
    clearUnsupportedPublicHoliday() {
      // 22.5 的 public_holiday 只在部分 sort_type 生效；切到不支援的條件時清空，
      // 避免回顯顯示了篩選、實際請求卻沒帶參數
      if (!this.publicHolidaySupported) {
        this.selectedPublicHoliday = ''
        this.selectedPublicHolidayShow = ''
        this.$emit('handlePublicHolidayChange', '')
      }
    },
    // 點表頭：只改展示排序 order_by（名單與 total 不變）；
    // 首次點該欄的方向見欄位的 sortDirection，同欄再點則升降互換
    handleSortChanged(ctx) {
      if (this.type !== 'toprank' || !ctx || !ctx.sortBy) {
        return
      }
      const field = this.currentTableFields.filter(
        (el) => el.key === ctx.sortBy
      )
      this.sortFieldKey = ctx.sortBy
      this.orderBy =
        field.length > 0 && field[0].apiKey ? field[0].apiKey : ctx.sortBy
      this.sortDesc = !!ctx.sortDesc
      // 記下這次排序的欄位，等請求回來才標藍
      this.sortHighlightKey = ctx.sortBy
      this.$emit('handleCriteriaChange', this.sortParam())
      // 點表頭是直接對表格下指令，立即重查；「搜尋條件」radio 則等使用者按 Search
      // （不經過 search()，避免清掉剛記下的 sortHighlightKey）
      this.$emit('handleSearch')
    },
    handleServerPageChange(page) {
      // 翻頁不是表頭排序請求 → 資料回來時還原藍底
      this.sortHighlightKey = ''
      this.$emit('pageChange', page)
    },
    // 切換榜單類型（radio）：名單與 total 會變，order_by 一併重置為該指標、方向由高至低
    handleCriteriaChange(val) {
      const arrfinder = this.optionsCriteria.filter(function (ele) {
        return ele.value === val
      })
      this.selectedCriteriaShow =
        arrfinder.length > 0 ? arrfinder[0].text : val
      this.orderBy = val
      this.sortFieldKey = arrfinder.length > 0 ? arrfinder[0].key : ''
      this.sortDesc = true
      this.clearUnsupportedPublicHoliday()
      this.$emit('handleCriteriaChange', this.sortParam())
    },
    handleGenreChange() {
      let genre = ''
      let genreshow = ''
      this.selectedGenre.forEach((element, index) => {
        genre += `&film_cat[${index}]=${element}`
        const arrfinder = this.optionsGenre.filter(function (ele) {
          return ele.value === element
        })
        genreshow += `${arrfinder[0].text} /`
      })
      this.selectedGenreShow = genreshow
      this.$emit('handleGenreChange', genre)
    },
    handleLevelChange() {
      let rating = ''
      let ratingshow = ''
      this.selectedLevel.forEach((element, index) => {
        rating += `&rating[${index}]=${element}`
        const arrfinder = this.optionsLevel.filter(function (ele) {
          return ele.value === element
        })
        ratingshow += `${arrfinder[0].text} /`
      })
      this.selectedLevelShow = ratingshow
      this.$emit('handleLevelChange', rating)
    },
    handleVersionChange() {
      let version = ''
      let versionshow = ''
      this.selectedVersion.forEach((element, index) => {
        version += `&edition[${index}]=${element}`
        const arrfinder = this.optionsVersion.filter(function (ele) {
          return ele.value === element
        })
        versionshow += `${arrfinder[0].text} /`
      })
      this.selectedVersionShow = versionshow
      this.$emit('handleVersionChange', version)
    },
    handleOriginChange() {
      let origin = ''
      let originshow = ''
      this.selectedOrigin.forEach((element, index) => {
        origin += `&country[${index}]=${element}`
        const arrfinder = this.optionsOrigin.filter(function (ele) {
          return ele.value === element
        })
        originshow += `${arrfinder[0].text} /`
      })
      this.selectedOriginShow = originshow
      this.$emit('handleOriginChange', origin)
    },
    handleMonthChange() {
      let month = ''
      const monthshow = []
      this.selectedMonth.sort((a, b) => Number(a) - Number(b)).forEach((element, index) => {
        if (index === 0) {
          month += `${element}`
        } else {
          month += `,${element}`
        }
        const arrfinder = this.optionsMonth.filter(function (ele) {
          return ele.value === element
        })
        monthshow.push(arrfinder[0].text)
      })
      this.selectedMonthShow = `${monthshow.join('+')  }/`
      const monthParam = month ? `&month=${month}` : ''
      this.$emit('handleMonthChange', monthParam)
    },
    handleWeekdayChange(val) {
      const weekdayList = (Array.isArray(val) ? val : val ? [val] : [])
        .slice()
        .sort((a, b) => Number(a) - Number(b))
      // 多選以逗號連接，例如 weekday=6,7
      const weekday =
        weekdayList.length > 0 ? `&weekday=${weekdayList.join(',')}` : ''
      const weekdayshow = weekdayList
        .map((el) => {
          const arrfinder = this.optionsWeekday.filter(
            (ele) => ele.value === el
          )
          return arrfinder.length > 0 ? arrfinder[0].text : ''
        })
        .join('+')
      this.selectedWeekdayShow = weekdayshow ? `${weekdayshow}/` : ''
      this.$emit('handleWeekdayChange', weekday)
      this.emitWeekdayHolidayLogic()
    },
    publicHolidayText(val) {
      if (val === '1') {
        return '只限公眾假期'
      }
      if (val === '0') {
        return '排除公眾假期'
      }
      return ''
    },
    // 22.5：public_holiday 與 weekday 同構，以 query string 片段回傳
    handlePublicHolidayChange(val) {
      const text = this.publicHolidayText(val)
      this.selectedPublicHolidayShow = text ? `${text}/` : ''
      const param = text ? `&public_holiday=${val}` : ''
      this.$emit('handlePublicHolidayChange', param)
      this.emitWeekdayHolidayLogic()
    },
    // 22.5：輪次口徑與其他篩選同構，以 query string 片段回傳；首映＝不帶參數
    handleRunTypeChange(val) {
      const text = this.runTypeText(val)
      this.selectedRunTypeShow = val ? `${text}/` : ''
      const param = val ? `&run_type=${val}` : ''
      this.$emit('handleRunTypeChange', param)
    },
    runTypeText(val) {
      const arrfinder = this.runTypeOptions.filter(function (ele) {
        return ele.value === val
      })
      return arrfinder.length > 0 ? arrfinder[0].text : String(val || '')
    },
    // weekday_holiday_logic 只認 and / or；只在兩邊都設定且為 or 時才需要送出（不送＝and）
    emitWeekdayHolidayLogic() {
      const bothSet =
        this.selectedWeekday.length > 0 && !!this.selectedPublicHoliday
      let param = ''
      if (bothSet && this.selectedWeekdayHolidayLogic === 'or') {
        param = '&weekday_holiday_logic=or'
      }
      this.$emit('handleWeekdayHolidayLogicChange', param)
    },
    handleWeekdayHolidayLogicChange(val) {
      this.selectedWeekdayHolidayLogicShow =
        val === 'or' ? '周天∪公眾假期/' : ''
      this.emitWeekdayHolidayLogic()
    },
    // 戲院日：22.5 與 22.6.2 共用選項與排序（後端亦會去重升序）
    sortedTheatreDays(list) {
      return (Array.isArray(list) ? list : []).slice().sort()
    },
    theatreDayText(list) {
      return list
        .map((el) => {
          const arrfinder = this.optionsTheatreDays.filter(
            (ele) => ele.value === el
          )
          return arrfinder.length > 0 ? arrfinder[0].text : el
        })
        .join('+')
    },
    // 22.5：與 weekday 同構，以 query string 片段回傳（逗號串）
    handleTheatreDayChange(val) {
      const list = this.sortedTheatreDays(val)
      this.selectedTheatreDaysShow =
        list.length > 0 ? `${this.theatreDayText(list)}/` : ''
      const param = list.length > 0 ? `&theatre_days=${list.join(',')}` : ''
      this.$emit('handleTheatreDayChange', param)
    },
    // 22.6.2：走結構化 payload
    handlePayloadTheatreDayChange(val) {
      const list = this.sortedTheatreDays(val)
      this.selectedTheatreDaysShowPayload =
        list.length > 0 ? `${this.theatreDayText(list)}/` : ''
      this.emitFilterPayload()
    },
    // 公眾假期不含週日：「星期日 + 只限公眾假期 + AND」恆為空集
    isHolidaySundayEmpty(weekdayList, logic, publicHoliday) {
      if (publicHoliday !== '1' || logic !== 'and') {
        return false
      }
      return (weekdayList || [])
        .map((el) => String(el))
        .indexOf('7') > -1
    },
    // 22.6.2：走結構化 payload
    handlePayloadPublicHolidayChange(val) {
      const text = this.publicHolidayText(val)
      this.selectedPublicHolidayShowPayload = text ? `${text}/` : ''
      this.emitFilterPayload()
    },
    handlePayloadWeekdayHolidayLogicChange(val) {
      this.selectedWeekdayHolidayLogicShowPayload =
        val === 'or' ? '周天∪公眾假期/' : ''
      this.emitFilterPayload()
    },

    // ---------- 22.6.2 最高票房日期（最好生意）：结构化 payload ----------
    // 与上面的 handleXxxChange 不同，这里不发 query string 片段，而是发数组给父组件组 JSON body
    emitFilterPayload() {
      if (this.type !== 'dayboxoffice') {
        return
      }
      this.$emit('filterPayloadChange', {
        dateStart: this.from,
        dateEnd: this.to,
        weekday: this.payloadWeekday
          .map((el) => Number(el))
          .filter((el) => el >= 1 && el <= 7),
        month: this.payloadMonth
          .map((el) => Number(el))
          .filter((el) => el >= 1 && el <= 12),
        specialDays: this.payloadHolidayGroups
          .map((group) => group.selectedHoliday)
          .filter((el) => !!el),
        // '' = 不篩選；'1' / '0' 由頁面轉成數值後才送出
        publicHoliday: this.payloadPublicHoliday,
        // 'and'（預設）/ 'or'，由頁面決定是否送出
        weekdayHolidayLogic: this.payloadWeekdayHolidayLogic,
        // 戲院日：空陣列 = 不篩選
        theatreDays: this.sortedTheatreDays(this.payloadTheatreDays)
      })
    },
    payloadWeekdayText(val) {
      const arrfinder = this.payloadWeekdayOptions.filter(function (ele) {
        return ele.value === String(val)
      })
      return arrfinder.length > 0 ? arrfinder[0].text : ''
    },
    handlePayloadWeekdayChange() {
      const show = this.payloadWeekday
        .slice()
        .sort((a, b) => Number(a) - Number(b))
        .map((el) => this.payloadWeekdayText(el))
        .join('+')
      this.selectedWeekdayShowPayload = show ? `${show}/` : ''
      this.emitFilterPayload()
    },
    handlePayloadMonthChange() {
      const show = this.payloadMonth
        .slice()
        .sort((a, b) => Number(a) - Number(b))
        .map((el) => {
          const arrfinder = this.optionsMonth.filter(function (ele) {
            return ele.value === String(el)
          })
          return arrfinder.length > 0 ? arrfinder[0].text : ''
        })
        .join('+')
      this.selectedMonthShowPayload = show ? `${show}/` : ''
      this.emitFilterPayload()
    },
    handlePayloadEnableHolidayChange(val) {
      if (val && this.payloadHolidayGroups.length === 0) {
        this.addPayloadHolidayGroup()
      } else if (!val) {
        this.payloadHolidayGroups = []
        this.selectedHolidayShowPayload = ''
        this.emitFilterPayload()
      }
    },
    addPayloadHolidayGroup() {
      this.payloadHolidayGroups.push({
        selectedHoliday: '',
        holidayName: ''
      })
      this.updatePayloadHolidayShow()
    },
    removePayloadHolidayGroup(index) {
      this.payloadHolidayGroups.splice(index, 1)
      this.updatePayloadHolidayShow()
    },
    handlePayloadHolidayChange(val, index) {
      const group = this.payloadHolidayGroups[index]
      const holiday = this.allHolidayList.find((h) => h.code === val)
      group.holidayName = holiday ? holiday.name : ''
      this.updatePayloadHolidayShow()
    },
    updatePayloadHolidayShow() {
      const names = this.payloadHolidayGroups
        .filter((group) => group.selectedHoliday && group.holidayName)
        .map((group) => group.holidayName)
      this.selectedHolidayShowPayload = names.length > 0 ? `${names.join('+')}/` : ''
      this.emitFilterPayload()
    },

    search() {
      // Search 按鈕：不是表頭排序請求 → 資料回來時還原藍底
      this.sortHighlightKey = ''
      this.$emit('handleSearch')
    },
    goBackReport() {
      this.$router.push({ name: this.path, query: this.returnData })
    },
    updateDDT(selected) {
      const date = selected
      this.disabledDatesTo.to = selected
      if (new Date(this.to) < new Date(this.disabledDatesTo.to)) {
        this.to = this.disabledDatesTo.to
      }
    },
    updateDDF(selected) {
      this.disabledDatesFrom.from = this.$moment(selected).format('YYYY-MM-DD')

      if (new Date(this.from) < new Date(this.disabledDatesTo.from)) {
        this.from = this.disabledDatesTo.from
      }
    },
    findfromarray() {}
  }
}
</script>
<style lang="scss">
.title {
  width: 100%;
  border-bottom: 2px solid #0e72bc;
  color: #0e72bc;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}
.table-name:hover {
  text-decoration: underline;
}
.line {
  height: 1.5px;
  background: #0e72bc;
  width: 100%;
  margin: 20px 0;
}
.sub-title {
  width: 100%;
  color: #0e72bc;
  font-size: 16px;
  font-weight: 500;
  margin: 20px 0 0;
}
.black-text {
  color: black;
}
.report-table {
  .b-table {
    thead {
      tr {
        th {
          div {
            white-space: normal;
          }
        }
      }
    }
  }
}
// sticky-header 方案：th 的 position: sticky 由 bootstrap-vue 自带（.b-table-sticky-header 内），这里只补背景，避免滚动时内容从表头透出
.sticky-thead th {
  background-color: #fff;
}
// 保证 18 列不被挤压；超出容器宽度时，由 sticky-header 容器提供横向滚动（body 的 overflow-x: hidden 不会裁剪它）
.sticky-table {
  min-width: 1800px;
}
.filter-text {
  line-height: 1.5;
}

// 筛选条件颜色 - 对阅读友好的配色
.filter-criteria {
  color: #2196F3; // 蓝色 - 累積票房等排序条件
  font-weight: 500;
}

.filter-genre {
  color: #4CAF50; // 绿色 - 片种
  font-weight: 500;
}

.filter-level {
  color: #FF9800; // 橙色 - 级别
  font-weight: 500;
}

.filter-version {
  color: #9C27B0; // 紫色 - 版本
  font-weight: 500;
}

.filter-origin {
  color: #00BCD4; // 青色 - 产地
  font-weight: 500;
}

.filter-holiday {
  color: #E91E63; // 粉红色 - 特殊节日
  font-weight: 500;
}

.filter-public-holiday {
  color: #607D8B; // 蓝灰色 - 公众假期
  font-weight: 500;
}

.filter-weekday-holiday-logic {
  color: #009688; // 蓝绿色 - 周天与公众假期的组合逻辑
  font-weight: 500;
}

.filter-month {
  color: #795548; // 棕色 - 月份
  font-weight: 500;
}

.filter-theatre-day {
  color: #2E7D32; // 深绿色 - 戏院日
  font-weight: 500;
}

.filter-weekday {
  color: #3F51B5; // 靛蓝色 - 周天
  font-weight: 500;
}

.filter-run-type {
  color: #455A64; // 深藍灰 - 輪次口徑（首映／重映／全部）
  font-weight: 500;
}

.filter-separator {
  color: #9E9E9E; // 灰色分隔符
  margin: 0 2px;
}

.search-country {
  width: 200px;
}

.holiday-group-item {
  padding: 10px;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.text-red {
  color: red !important;
  font-weight: bold;
}
</style>
